<template>
    <b-modal
        id="edit"
        title="Editar Comentário"
        hide-footer>
        <b-overlay :show="loading" rounded="sm">
            <b-form @submit="submit" @submit.stop.prevent>

                <!-- Field -->
                <b-form-group
                    label="Atalho do Comentário"
                    description="O atalho deve ser a palavra chave para que substitua o comentário completo">

                    <!-- Input -->
                    <b-form-input
                        v-model="form.name"
                        placeholder="Ex: virgula, crase, etc ..."
                        :state="hasErrors('name', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="name" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Conteúdo do Comentário"
                    description="Qual o texto que deseja inserir quando usar o atalho colocado no campo anterior ?">

                    <!-- Input -->
                    <b-textarea
                        v-model="form.char"
                        rows="6"
                        placeholder="Ex: Se tiver setado o nome como 'virgula', o conteudo agora seria exatamente a descrição completa desse erro"
                        :state="hasErrors('char', errors)"
                    ></b-textarea>

                    <!-- Error -->
                    <has-errors :errors="errors" name="char" />
                </b-form-group>

                <!-- Submit -->
                <b-button type="submit" variant="primary" :disable="loading">
                    Editar Comentário
                </b-button>

            </b-form>
        </b-overlay>
    </b-modal>
</template>

<script>
export default {
    props: ['endpoint'],
    data() {
        return {
            loading: false,
            errors: {},
            id: null,
            form: {
                name: null,
                char: null,
            }
        }
    },
    created() {
        this.$root.$on('editPreComment', (event) => {

            // Set Form
            this.id = event.id
            this.form.name = event.name
            this.form.char = event.char

            // Modal
            this.$bvModal.show('edit')

        })
    },
    methods: {
        submit() {
            this.loading = true;
            axios.put(this.endpoint + '/' + this.id, this.form)
                .then((result) => {
                    // Callback
                    this.$emit('updated')

                    // Close Modal
                    this.$bvModal.hide('edit')

                    // Message
                    this.$toast.success('Comentário editado com sucesso !')

                    // Clear Form
                    this.form = {
                        name: null,
                        char: null
                    }

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
